import HeroSection from '../components/HeroSection';
// import FavoriteSection from '../components/FavoriteSection';
import ThemeSection from '../components/ThemeSection';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <ThemeSection />
    </>
  );
}
